export default "__VITE_ASSET__CyfPqWg___"